import PropTypes from 'prop-types';

import {
  VALID_SOCIAL_LINK_SERVICE_NAMES
} from 'zoomforth_codesbane_viewer/viewer/header_legacy/social_link_icon.jsx';

import {
  LINK_TYPE_INTERNAL,
  LINK_TYPE_EXTERNAL
} from 'zoomforth_codesbane_viewer/const/link_types.js';

import {
  VALID_GRID_TAXONOMY_FILTER_TYPES,
  VALID_GRID_TAXONOMY_FILTER_LOGICAL_OPERATORS
} from 'grid_taxonomy.js';

// `menuAction` can completely describe the action to take place
// when the menu is interacted with 

const appActionExternal = PropTypes.shape({
  type: PropTypes.oneOf([LINK_TYPE_EXTERNAL]).isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired
});

const appActionInternal = PropTypes.shape({
  type: PropTypes.oneOf([LINK_TYPE_INTERNAL]).isRequired,
  subpageId: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
  contentUuid: PropTypes.number,
  shouldOpenOVerlay: PropTypes.bool
});

const appActionNone = PropTypes.shape({
  type: PropTypes.oneOf(['none']).isRequired
});

const appActionOverlay = PropTypes.shape({
  type: PropTypes.oneOf(['overlay']).isRequired,
  contentUuid: PropTypes.string.isRequired
});

const appActionDownload = PropTypes.shape({
  type: PropTypes.oneOf(['download']).isRequired,
  contentUuid: PropTypes.string.isRequired
});

const Component = PropTypes.oneOfType([
  PropTypes.instanceOf(Component),
  PropTypes.func
]);


const menuAppAction = PropTypes.oneOfType([
  appActionExternal,
  appActionInternal
]);


const tileAppAction = PropTypes.oneOf([
  appActionInternal,
  appActionExternal,
  appActionNone,
  appActionOverlay,
  appActionDownload
]);

const menuItem = PropTypes.shape({
  title: PropTypes.string.isRequired,
  appAction: menuAppAction.isRequired
});

const socialLink = PropTypes.shape({
  link: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  serviceName: PropTypes.oneOf(VALID_SOCIAL_LINK_SERVICE_NAMES).isRequired
});

const gridTaxonomyTag = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
});

const gridTaxonomyCategory = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
  priority: PropTypes.number,
  tags: PropTypes.arrayOf(gridTaxonomyTag).isRequired
});

const gridTaxonomyFilterType = PropTypes.oneOf(VALID_GRID_TAXONOMY_FILTER_TYPES);
const gridTaxonomyFilterLogicalOperator = PropTypes.oneOf(VALID_GRID_TAXONOMY_FILTER_LOGICAL_OPERATORS);

const gridTaxonomy = PropTypes.shape({
  version: PropTypes.number.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  filterMeta: PropTypes.shape({
    type: gridTaxonomyFilterType.isRequired,
    logicalOperator: gridTaxonomyFilterLogicalOperator.isRequired,
    toggleText: PropTypes.string.isRequired
  }).isRequired,
  categories: PropTypes.arrayOf(gridTaxonomyCategory).isRequired
});

const tileTaxonomy = PropTypes.shape({
  version: PropTypes.number.isRequired,
  tagIds: PropTypes.array.isRequired
});

export default {
  Component,
  menuAppAction,
  tileAppAction,
  menuItem,
  socialLink,
  tileTaxonomy,
  gridTaxonomy,
  gridTaxonomyCategory,
  gridTaxonomyTag,
  gridTaxonomyFilterType,
  gridTaxonomyFilterLogicalOperator 
};
